import styled from 'styled-components';
import { TableRow } from '../metrics-table/table';
import { breakpoints } from '../../styles/variables';

export const Wrapper = styled.div`
  flex: 1;
  margin: 0 auto 2rem;
  max-width: var(--widget-max-width);
  width: 100%;

  @media (max-width: ${breakpoints.TABLET_SIZE}) {
    max-width: 100%;
  }
`;

export const ClickableTableRow = styled(TableRow)`
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: rgb(228, 241, 254);
  }
`;

export const NoWrapSpan = styled.span`
  white-space: nowrap;
`;